import { Platform } from "react-native";
import { takeLeading, put } from "redux-saga/effects";
import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";
import {
  setReleaseNotes,
  getReleaseNotesData,
  releaseNotesCallComplete,
} from "../../slices/GlobalSlice";
import { normalizeReleaseData } from "../../../hooks/useReleaseData";
import type { ReleasePlatform } from "../../../types/releaseData";

export default function* releaseNotesSaga(): Generator<any, void, any> {
  const isWeb = Platform.OS === "web";
  const platformTag: ReleasePlatform = isWeb
    ? "newUI_Web"
    : Platform.OS === "ios"
      ? "newUI_iOS"
      : "newUI_Android";

  function* fetchReleaseNotesSaga(action: any): Generator<any, void, any> {
    try {
      const endpoint = ENDPOINT.COMMON.getReleaseNotes
        ? ENDPOINT.COMMON.getReleaseNotes()
        : "releasenotes";

      const response: any = yield api.request({
        method: "GET",
        url: endpoint,
        skipGlobalLoader: true,
      } as any);

      const normalizedReleases = normalizeReleaseData(response, platformTag);

      if (normalizedReleases && normalizedReleases.length > 0) {
        const hashKey =
          response?.hashKey ||
          response?.data?.hashKey ||
          (normalizedReleases.length > 0 ? normalizedReleases[0].version : "");

        yield put(
          setReleaseNotes({
            releases: normalizedReleases,
            hashKey,
          }),
        );

        if (isWeb) {
          console.log(
            "Release Notes Saga: Announcements normalized and stored in Redux:",
            normalizedReleases,
          );
        }

        if (action?.payload?.callback) {
          yield action.payload.callback({ hashKey, releases: normalizedReleases });
        }
      }
    } catch (error) {
      console.error("Release Notes Saga: Error fetching release notes", error);
    } finally {
      yield put(releaseNotesCallComplete());
    }
  }

  yield takeLeading(getReleaseNotesData.type, fetchReleaseNotesSaga);
}
